export default {
  type: 'internal_users',
  name: 'Metrics Exclusions',
  description: 'All users marked to be excluded from metrics',
  search: {
    search: 'allPeople',
    orderBy: {
      type: 'PeopleOrderBy',
      default: 'FULL_NAME_ASC'
    },
    conditions: {
      internalUser: { type: 'Boolean', required: true, default: true }
    },
    fields: [
      { name: 'personId', searchable: false },
      { name: 'fullName', label: 'Name', searchable: false },
      { name: 'username', searchable: false },
      { name: 'email', searchable: false },
      { name: 'affiliation', searchable: false },
      { name: 'accessStatement', searchable: false },
      { name: 'scienceUser', type: 'boolean', searchable: false }
    ]
  }
}
